import {
  DataTableColumnTextProps,
  DataTableColumnVariant,
  DataTableVariant,
  DynamicDataTable,
  DynamicDataTableColumn,
} from '@/components/data-table-builder/data-table.types';

interface ISeuilDataTableProps {
  store: any;
  createAction?: () => void;
  rowActions?: any;
}

export const getSeuilDataTableStructure = ({ store, createAction, rowActions }: ISeuilDataTableProps): DynamicDataTable => {
  const typeMarcheColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'settings.seuils.table.typeMarche',
    accessorKey: 'id.typeMarcher.description',
    variant: DataTableColumnVariant.TEXT,
  };

  const seuilColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'settings.seuils.table.seuil',
    accessorKey: 'seuil',
    variant: DataTableColumnVariant.TEXT,
  };

  return {
    singular: 'settings.seuils.table.singular',
    plural: 'settings.seuils.table.plural',
    columns: [typeMarcheColumn, seuilColumn],
    variant: DataTableVariant.COMMON,
    sizes: [30, 40, 30],
    stripedRows: true,
    target: row => {
      store.set('response', row);
      store.set('dto', {
        acId: row.id.ac.id,
        typeMarcherId: row.id.typeMarcher.id,
        seuil: row.seuil,
      });
    },
    createAction,
    rowActions,
    searchableFields: ['id.typeMarcher.code', 'seuil'],
  };
};
